module.exports = __webpack_public_path__ + "static/assets/0981d9ea7d2f08b42667c54887b3feb4.png";